import { render, staticRenderFns } from "./ProjectAdBudgetCreate.vue?vue&type=template&id=3bf5e1d2"
import script from "./ProjectAdBudgetCreate.vue?vue&type=script&lang=js"
export * from "./ProjectAdBudgetCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports